// Desktop-launch query params: when the SPA is opened from the desktop wrapper
// with ?deviceId=&clientId=&app=desktop, read those values DIRECTLY from the
// current URL at request time and inject them into the two auth payloads
// (User/login, User/selectLgnRegMethod).
//
// No persistence: the login page renders at `/` (WebTab: <Route exact path="/">)
// with the query intact all the way to the auth call, so reading window.location
// is reliable. Because nothing is stored, behavior depends only on how the app
// was launched — there is no stale state to leak into a normal web login.

// Read the desktop-launch params from the current URL. Returns
// { ClientId?, DeviceID?, RequestFrom? } with only the non-empty values present,
// or null when the app was not launched with any desktop params.
export function getDesktopParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    const clientId = (params.get("clientId") || "").trim();
    const deviceId = (params.get("deviceId") || "").trim();
    const app = (params.get("app") || "").trim();

    const result = {};
    if (clientId) result.ClientId = clientId;
    if (deviceId) result.DeviceID = deviceId;
    if (app) result.RequestFrom = app;

    return Object.keys(result).length > 0 ? result : null;
  } catch (err) {
    console.error("getDesktopParams failed:", err);
    return null;
  }
}

// Override ClientId/DeviceID/RequestFrom on an outgoing payload with the
// desktop-launch values read from the URL. No-op on a normal (non-desktop)
// launch, so existing parameter passing is left completely untouched.
export function applyDesktopParams(requestParams) {
  const params = getDesktopParams();
  if (params) {
    Object.assign(requestParams, params);
  }
  return requestParams;
}
